import { Result } from "./../models/Result.model";
import { Injectable } from "@angular/core";
import { Consultant } from "../models/Consultant.model";
import { Additive } from "../models/Additive.model";
import { HttpClient } from "../shared/wrappers/HttpClient";
import { DropDownList } from "../models/DropDownList.model";
import { ConsultantSearch } from "../models/ConsultantSearch.model";
import { ContractType } from "../shared/enums/ContractType";
import { HonorariumType } from "../shared/enums/HonorariumType";
import { ToastsManager } from "ng2-toastr";
import { IPublicConsultantDTO } from "../views/consultants/public-consultant-edit/interfaces";
import { ErrorHandlerProvider } from "../shared/providers/errorHandler.provider";
import * as bluebird from 'bluebird';
import * as _ from 'lodash';
import { SelfFill } from '../models/SelfFill.model';
import { SelfFillRequestStatus } from "../shared/enums/SelfFillRequestStatus";
import { SubDivision } from '../models/SubDivision.model';
import { FreshServiceOffboardingForm } from "../models/FreshServiceOffboardingForm.model";

@Injectable()
export class ConsultantService {
    constructor(private httpClient: HttpClient,
                public toastr:ToastsManager,
                private errorHandler: ErrorHandlerProvider) { }

    endPoint: String = "/consultants";
    endPointDocusign: String = "/docusign";
    endPointFreshService: String = "/freshServiceConsultant";
    endPointConsultantSelfFill: String = "/consultant-self-fill"
    selfFillPublic: String = "/consultant-self-fill-public";

    async searchConsultants(consultantSearch: ConsultantSearch): Promise<Consultant[]> {
        var queryString = "?";

        if (consultantSearch.name){
            queryString += `name=${consultantSearch.name}`;
        }
        if (consultantSearch.email){
            if (queryString !== "") queryString += "&";
            queryString += `email=${consultantSearch.email}`;
        }
        if (consultantSearch.kind){
            if (queryString !== "") queryString += "&";
            queryString += `kind=${consultantSearch.kind}`;
        }
        if (consultantSearch.customerActive){
            if (queryString !== "") queryString += "&";
            queryString += `customerActive=${consultantSearch.customerActive}`;
        }
        if (consultantSearch.responsible){
            if (queryString !== "") queryString += "&";
            queryString += `responsible=${consultantSearch.responsible}`;
        }

        if (consultantSearch.excellenceCenter){
            for (var i = 0; i < consultantSearch.excellenceCenter.length; i++) {
                if (queryString !== "") queryString += "&";
                    queryString += `excellenceCenter=${consultantSearch.excellenceCenter[i]}`;
            }
        }

        if (consultantSearch.supportCenter){
            for (var i = 0; i < consultantSearch.supportCenter.length; i++) {
                if (queryString !== "") queryString += "&";
                    queryString += `supportCenter=${consultantSearch.supportCenter[i]}`;
            }
        }

        if (consultantSearch.division !== null && consultantSearch.division.length > 0) {
            for (var i = 0; i < consultantSearch.division.length; i++) {
                if (queryString !== "") queryString += "&";

                queryString += `division=${consultantSearch.division[i]}`;
            }
        }

        if (consultantSearch._id !== null && consultantSearch._id.length > 0) {
            for (var i = 0; i < consultantSearch._id.length; i++) {
                if (queryString !== "") queryString += "&";

                queryString += `_id=${consultantSearch._id[i]}`;
            }
        }

        if (consultantSearch.fields !== null && consultantSearch.fields.length > 0) {
            for (var i = 0; i < consultantSearch.fields.length; i++) {
                if (queryString !== "") queryString += "&";

                queryString += `field=${consultantSearch.fields[i]}`;
            }
        }

        if (consultantSearch.companyName){
            if (queryString !== "") queryString += "&";
            queryString += `companyName=${consultantSearch.companyName}`;
        }

        if (consultantSearch.cnpj){
            if (queryString !== "") queryString += "&";
            queryString += `cnpj=${consultantSearch.cnpj}`;
        }

        if (queryString !== "?")
            queryString += "&";

        queryString += `limit=${consultantSearch.limit}`;

        if(consultantSearch.skip >= 0){
            queryString += `&skip=${consultantSearch.skip}`;
        }

        if (consultantSearch.onlyActives) {
            queryString += `&active=true`;
        } else if (consultantSearch.onlyInactives) {
            queryString += `&active=false`;
        }

        if (consultantSearch.onlyContractGenerated) {
            queryString += `&contractgenerated=true`;
        } else if (consultantSearch.onlyContractNotGenerated) {
            queryString += `&contractgenerated=false`;
        }

        var consultantsModel = new Array<Consultant>();

        let url = `${this.endPoint}/search${queryString}`;
        var response = await this.httpClient.get(url);

        for (let c of response.consultants) {
            var con = new Consultant();
            con.loadConsultantFromServer(c);
            consultantsModel.push(con);
        }

        consultantSearch.totalItems = response.totalItems;
        return consultantsModel;
    }

    async create(consultant: Consultant) {
        return await this.httpClient.post(this.endPoint, consultant);
    }

    async edit(consultant: Consultant) {
        return await this.httpClient.update(
            this.endPoint,
            consultant._id,
            consultant
        );
    }

    async getById(id: string): Promise<Consultant> {
        var consultantToEdit = new Consultant();
        var response = await this.httpClient.get(`${this.endPoint}/${id}`);
        consultantToEdit.loadConsultantFromServer(response);
        return consultantToEdit;
    }

    async getAll(queryString): Promise<Result<Array<Consultant>>> {
        const res = await this.httpClient.get(`${this.endPoint}/search?${queryString}`);

        return new Result<Array<Consultant>>(res.consultants, {
            totalItems: res.totalItems
        });
    }


    async listAll(onlyActive = true): Promise<Consultant[]> {
        var response = await this.httpClient.get(`${this.endPoint}?onlyActive=${onlyActive}`);
        return response;
    }

    FromDropDownListToConsultant(source: Array<DropDownList>) {
        var consultants = new Array<Consultant>();
        for (let i of source) {
            var consultant = new Consultant();
            consultant._id = i.id;
            consultant.name = i.itemName;
            consultants.push(consultant);
        }

        return consultants;
    }

    isContractTypePJ(consultant: Consultant) {
        return consultant.contract.kind === ContractType.PJ;
    }

    verifyCalcHourValue(consultant: Consultant) {
        let type = consultant.contract.kind;
        let honor = consultant.contract.honorarium;

        if (type === ContractType.PJ
            && honor == HonorariumType.ClosedHour
            && consultant.contract.totalValue > 0
            && consultant.contract.mensalHours > 0) {

            consultant.contract.hourValue = this.calculateHourValue(consultant);
            //return true;
        }
        return true;
    }

    calculateHourValue(consultant: Consultant): number {

        if (consultant.contract.mensalHours > 0 && consultant.contract.totalValue > 0) {
            let qtdHours = consultant.contract.mensalHours.toString();
            let totalValue = consultant.contract.totalValue.toString();
            return parseFloat((parseFloat(totalValue) / parseFloat(qtdHours)).toFixed(5));
        }

        return 0;
    }

    calculateHourValueBenefits(consultant: Consultant): number {
        if (consultant.contract && consultant.contract.mensalHours > 0 && consultant.contract.totalCostWithBenefits > 0) {
            let qtdHours = consultant.contract.mensalHours.toString();
            let totalCost = consultant.contract.totalCostWithBenefits.toString();
            return parseFloat((parseFloat(totalCost) / parseFloat(qtdHours)).toFixed(5));
        }
        return 0;
    }

    async verifyCPF(consultant: Consultant): Promise<Consultant[]> {
        let response = await this.httpClient.post(`${this.endPoint}/cpf`, consultant);
        return response
    }

    async notifyDP(consultant: Consultant | IPublicConsultantDTO, departament: Number, type: Number){
        try{
            const data = { consultant, departament, type };
            let response = await this.httpClient.post(`${this.endPoint}/notifydp`, data);
            if(response.success){
                this.toastr.success("E-mail enviado com sucesso");
                return true;
            } else {
                this.errorHandler.interceptError(response, 'Consultor');
                return false;
            }
        } catch (error) {
            this.errorHandler.interceptError(error, 'Consultor');
            return false;
        }
    }

    async generateContract(consultant: Consultant) {
        return await this.httpClient.post(`${this.endPoint}/contract`, consultant);
    }

    async generateAdditive(consultant: Consultant, additive: Additive) {
        try{
            const data = { consultant, additive };
            return await this.httpClient.post(`${this.endPoint}/additive`, data);
        } catch (error) {
            this.errorHandler.interceptError(error, 'Consultor');
            return false;
        }
    }

    async generateDistract(consultant: Consultant) {
        return await this.httpClient.post(`${this.endPoint}/distract`, consultant);
    }

    async generateDischarge(consultant: Consultant) {
        return await this.httpClient.post(`${this.endPoint}/discharge`, consultant);
    }

    async generateConfidentialityTerm(consultant: Consultant) {
        return await this.httpClient.post(`${this.endPoint}/confidentiality`, consultant);
    }

    async generateIndividualAgreementHolidayTerm(consultant: Consultant) {
        return await this.httpClient.post(`${this.endPoint}/individual-agreement-holiday`, consultant);
    }

    async withoutSapCardCode(consultant: Consultant) {
        return await this.httpClient.post(`${this.endPoint}/without-sap`, consultant);
    }

    async getCnpj(cnpj: String, simei: boolean = false){
        let cnpjNumber = this.cnpjRemoveSpecialCharacters(cnpj);
        return await this.httpClient.get(`${this.endPoint}/cnpj/${cnpjNumber}${simei ? '?simei=true': ''}`);
    }

    cnpjRemoveSpecialCharacters(cnpj: String) {
        let cnpjNumber = cnpj.trim();
        cnpjNumber = cnpjNumber.replace(/\./g, "");
        cnpjNumber = cnpjNumber.replace(/\//g, "");
        cnpjNumber = cnpjNumber.replace(/\_/g, "");
        cnpjNumber = cnpjNumber.replace(/\-/g, "");
        return cnpjNumber;
    }

    cnpjValid(cnpj: String) {
        if(this.cnpjRemoveSpecialCharacters(cnpj).length == 14)
            return true;
        return false;
    }

    randomPixKeyValid(pixKey: String){
        if (pixKey.length == 36)
            return true;
        return false;
    }

    async getCep(cep: String){
        let cepNumber = cep.replace(/\-/g, "");
        let response = await this.httpClient.get(`${this.endPoint}/cep/${cepNumber}`);
        return response;
    }

    async getCepPublicRoute(cep: String){
        let cepNumber = cep.replace(/\-/g, "");
        let response = await this.httpClient.get(`${this.selfFillPublic}/cep/${cepNumber}`);
        return response;
    }

    async getAllContractProfile(){
        let response = await this.httpClient.get(`${this.endPoint}/contract-profiles`);
        return response;
    }

    async changeContract(id, data){
        let response = await this.httpClient.update(`${this.endPoint}/change-contract`, id, data);
        return response;
    }

    async getAllSkills() {
        let response = await this.httpClient.get(`${this.endPoint}/skills`);
        return response;
    }

    async createSkill(skill: string) {
        return await this.httpClient.post(`${this.endPoint}/skills`, { name: skill });
    }

    async getDocumentsClickSign(documentsClickSign: any) {
        return await this.httpClient.post(`${this.endPoint}/clicksign`, documentsClickSign);
    }

    async generateBorrowedInvoiceDeclarationNote(consultant: Consultant): Promise<Consultant | any> {
        return await this.httpClient.post(`${this.endPoint}/declaration`, consultant);
    }

    async createMultipleConsultants(consultants: Consultant[]) {
        return bluebird.map(consultants, (consultant) => {
            return this.httpClient.post(this.endPoint,
            _.cloneDeep(consultant))
        }, { concurrency: 20 });
    }

    async convertConsultantsCsvToJson(file: File): Promise<any> {
        let data: FormData = new FormData();
        data.append('file', file, file.name);
        return await this.httpClient.postFile(`/upload-file/consultant`, data);
    }

    async getAllDocusignDocuments(consultantIds: String[]): Promise<any> {
        return await this.httpClient.post(`${this.endPointDocusign}/finished-documents`, {consultantIds});
    }

    async getConsultantSelfFill(_id: String): Promise<any> {
        return await this.httpClient.get(`${this.endPointConsultantSelfFill}/${_id}`);
    }

    async updateApproved(_id: String): Promise<any> {
        return await this.httpClient.update(`${this.endPointConsultantSelfFill}`, _id, {approvedStatus: SelfFillRequestStatus.Approved});
    }

    async updateReproved(_id: String): Promise<any> {
        return await this.httpClient.update(`${this.endPointConsultantSelfFill}`, _id, {approvedStatus: SelfFillRequestStatus.Reproved});
    }

    async sendMassRequest(data: {consultants: Array<string>}) {
        return await this.httpClient.post(`${this.endPointConsultantSelfFill}/request-self-fill`, data);
    }

    async saveSelfFillData(consultantData: SelfFill) {
        const data = {
            updatedFields: consultantData
        }
        return await this.httpClient.update(`${this.selfFillPublic}`, data.updatedFields.hash, data);
    }

    async getSelfFillData(hash: string) {
        return await this.httpClient.get(`${this.selfFillPublic}/${hash}`);
    }

    checkIfCnpjIsMei(company) {
        const companyNameContainsCPF = (companyName) => {
            const element = companyName.split(' ').pop();
            return element.length == 11 && !isNaN(element);
        }

        const companyName = company.nome;
        const companyLegalNature = company.natureza_juridica;
        const companySize = company.porte;

        if(companyLegalNature.includes('213-5') &&
           companySize == 'MICRO EMPRESA' &&
           companyNameContainsCPF(companyName))
           return true;
        return false;
    }

    async getFreshServiceEmailByCPF(cpf: String): Promise<any> {
        return await this.httpClient.get(`${this.endPointFreshService}/${cpf}`);
    }

    async createTicket(data: Consultant | FreshServiceOffboardingForm | any, type: string): Promise<any> {
        return await this.httpClient.post(`${this.endPointFreshService}/ticket`, { data: data, type });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/consultant.service.ts